var formatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});
document.addEventListener("DOMContentLoaded", function () {
  var o = document.querySelector(".info-campaing");
  // if (o) {
  //   let e = o.querySelector(".collection-description"),
  //     t = o.querySelector(".read-more-btn"),
  //     n = e.innerHTML.trim(),
  //     a = n.slice(0, 175),
  //     r = !1;
  //   (e.innerHTML = `<span class="preview">${a}</span><span class="dots">...</span>`),
  //     t.addEventListener("click", () => {
  //       (r = !r)
  //         ? ((e.innerHTML = `<span class="full-text">${n}</span>`),
  //           (t.textContent = "Ler Menos"))
  //         : ((e.innerHTML = `<span class="preview">${a}</span><span class="dots">...</span>`),
  //           (t.textContent = "Ler Mais"));
  //     });
  // }
  new Swiper(".mySwiperCollection", {
    autoplay: { delay: 3e3, disableOnInteraction: !1 },
    loop: !0,
    pagination: {
      el: ".swiper-pagination",
      clickable: !0,
      type: "custom",
      renderCustom: function (e, t, n) {
        var a = "";
        for (i = 1; i < n + 1; i++)
          a =
            i == t
              ? a +
                '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' +
                i +
                ' role="button" aria-label="Go to slide ' +
                i +
                '1"></span>'
              : a +
                '<span class="swiper-pagination-bullet" tabindex=' +
                i +
                ' role="button" aria-label="Go to slide ' +
                i +
                '1"></span>';
        return a;
      },
    },
  });
  $(".mySwiperCollection").hover(
    function () {
      this.swiper.autoplay.stop();
    },
    function () {
      this.swiper.autoplay.start();
    }
  ),
    $("#formFilter").on("submit", function (e) {
      e.preventDefault();
      var e = new FormData(e.target),
        t = e.get("filter.v.price.gte"),
        n = e.get("filter.v.price.lte"),
        a = { maxPrice: n, minPrice: t },
        t = formatter.format(parseFloat(t / 100)).replace(/\s/g, "").replace(",", "."),
        n = formatter.format(parseFloat(n / 100)).replace(/\s/g, "").replace(",", "."),
        t =
          (e.set("filter.v.price.gte", t),
          e.set("filter.v.price.lte", n),
          decodeURIComponent(new URLSearchParams(e).toString()));
      localStorage.setItem("price-range", JSON.stringify(a)),
        $("body").hasClass("template-collection")
          ? (window.location.search = "?" + t)
          : $("body").hasClass("template-search") &&
            ((e = (n = window.location.search).indexOf("products")),
            (a = n.substring(0, e + 8)),
            0 < n.indexOf("filter")
              ? (window.location.search = a + "&" + t)
              : (window.location.search = n + "&" + t));
    }),
    1024 < $(window).width() &&
      $("#formFilter input").on("change", function (e) {
        $("#formFilter").submit();
      }),
    $("#slider-1").on("input", function () {
      var e;
      parseInt(t.value) >= parseInt(n.value) && (t.value = n.value),
        (e = formatter.format(t.value / 100).replace(/\s/g, "")),
        (a.textContent = "De " + e);
    }),
    $("#slider-2").on("input", function () {
      var e;
      parseInt(n.value) <= parseInt(t.value) && (n.value = t.value),
        (e = formatter.format(n.value / 100).replace(/\s/g, "")),
        (r.textContent = "Ate " + e);
    });
  let t = document.getElementById("slider-1"),
    n = document.getElementById("slider-2"),
    a = document.getElementById("range1"),
    r = document.getElementById("range2");
  if (
    ((o = JSON.parse(localStorage.getItem("price-range"))) &&
      ($(t).attr("value", o.minPrice),
      $(n).attr("value", o.maxPrice),
      $(a).html("De " + formatter.format(o.minPrice / 100).replace(/\s/g, "")),
      $(r).html("Até " + formatter.format(o.maxPrice / 100).replace(/\s/g, "")),
      localStorage.removeItem("price-range")),
    (Shopify.queryParams = {}),
    location.search.length)
  )
    for (
      var e = location.search.substr(1).split("&"), i = 0;
      i < e.length;
      i++
    ) {
      var l = e[i].split("="),
        s = decodeURIComponent(l[0]),
        c = decodeURIComponent(l[1]);
      l.length &&
        (Shopify.queryParams[s]
          ? Shopify.queryParams[s].push(c)
          : (Shopify.queryParams[s] = [c]));
    }
  function p(e) {
    (Shopify.queryParams.sort_by = e),
      (location.search = decodeURIComponent(
        new URLSearchParams(Shopify.queryParams).toString()
      ));
  }
  $("#sort-by li").on("click", function (e) {
    p($(this).data().value);
  }),
    $(".wrapper-select-sort-by select").on("change", function (e) {
      p(e.target.value);
    });
  var u = $(".search-result-items"),
    m = u.data("next-url"),
    d = $(".show_more_btn"),
    f = $(".load-more__spiner"),
    h = !1;
  window.addEventListener(
    "scroll",
    function () {
      h ||
        ((h = !0),
        ((e, t) => (
          ((e = e.getBoundingClientRect()).y = e.y - t),
          0 <= e.top &&
            0 <= e.left &&
            e.bottom <=
              (window.innerHeight || document.documentElement.clientHeight) &&
            e.right <=
              (window.innerWidth || document.documentElement.clientWidth)
        ))(d[0], 500) &&
          $.ajax({
            url: m,
            type: "GET",
            dataType: "html",
            beforeSend: function () {
              d.hide(), f.show();
            },
          }).done(function (e) {
            f.hide();
            var e = $(e).find(".search-result-items"),
              t = e.data("next-url");
            t && d.show(), (m = t), u.append(e.html()), formatStarInKitShelf();
          }),
        setTimeout(function () {
          h = !1;
        }, 500));
    },
    !0
  );
});
